import { render, staticRenderFns } from "./iCalDialog.vue?vue&type=template&id=655a501a"
import script from "./iCalDialog.vue?vue&type=script&lang=ts"
export * from "./iCalDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports